import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";

const styles = createUseStyles(theme => ({
  spinner: {
   display: "grid",
   justifyContent: "center",
   alignContent: "center",
   "& img": {
      width: "32px",
      height: "32px",
      animation: "$rotation 0.8s infinite linear",
    }
  },
  loadingText: {
    color: colors.grey,
    fontWeight: "500",
    fontSize: "14px",
  },
  "@keyframes rotation": {
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(360deg)"
    }
  }
}));

export default styles;

